export enum SortType {
  IDLE = 'idle',
  ASC = 'asc',
  DESC = 'desc',
}
